module.exports = __webpack_public_path__ + "img/EBST.c622a0a1.svg";